'use strict';

import * as React from "react";
import * as ReactDOM from "react-dom";
import $ from "jquery";
import ClipboardJS from "clipboard"

function chunk(filelist: any, chunkSize: number): FileList[] {
    const array = [];
    for (const file of filelist) {
        array.push(file);
    }
    const R = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        const list = new DataTransfer();
        const chunk = array.slice(i, i + chunkSize)
        chunk.forEach((item) => list.items.add(item))
        R.push(list.files);
    }
    return R;
}

/**
 * Shuffles array in place.
 */
function shuffle<T>(a: T[]): T[] {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}

async function getBucketItems(): Promise<GifMemeItem[]> {
    const response = await fetch("/gifs");
    return response.json();
}

function guidGenerator() {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4());
}

interface GifProps {
    origin: string;
    cdnLocation: string;
}

function GifMeme(props: GifProps) {
    return (
        <div className="card gif text-white" style={{ width: "18rem" }}>
            <img src={props.cdnLocation} className="card-img-top" alt={props.origin} />
            <div className="card-img-overlay">
                <p className="card-text"><a className="clipboard-link" data-clipboard-text={props.cdnLocation}><i className="far fa-copy"></i> Copy Link</a></p>
            </div>
        </div>
    );
}

interface GifMemeItem {
    origin: string;
    cdnLocation: string;
}
interface AppProps {
    objects: GifMemeItem[]
}

function App(props: AppProps) {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobileBreakpoint = width <= 768;
    return (
        <div className="container">
            <div className="card-columns">
                {shuffle(props.objects).map((obj) => <GifMeme key={obj.origin} origin={obj.origin} cdnLocation={obj.cdnLocation} />)}
            </div>
        </div>
    );
}

async function loadApp() {
    const objects = await getBucketItems()
    const domContainer = document.querySelector('#app');
    ReactDOM.render(<App objects={objects} />, domContainer);
    new ClipboardJS('.clipboard-link');
}
loadApp();

async function setFiles(e: DragEvent) {
    if (e.dataTransfer) {
        $('#loading').show();
        const droppedFiles = e.dataTransfer.files;

        const $form = $("form#upload");
        const formElement = $form[0] as HTMLFormElement
        const resultElement = formElement.children.namedItem("result");
        await Promise.all(chunk(droppedFiles, 3).map(async (filesChunk) => {
            $form.find('input[type="file"]').prop('files', filesChunk);
            const formData = new FormData($form.get(0) as HTMLFormElement);
            try {
                const response = await fetch(formElement.action, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    await loadApp()
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }));
        $("#loading").hide();
    }
}

function disableEvent(e: Event) {
    e.stopPropagation();
    e.preventDefault();
}

function onDrop(e: DragEvent) {
    e.stopPropagation();
    e.preventDefault();
    setFiles(e);
    return false;
}

const body = $('body')[0];
body.addEventListener('dragenter', disableEvent, false);
body.addEventListener('dragover', disableEvent, false);
body.addEventListener('dragleave', disableEvent, false);
body.addEventListener('drop', onDrop, false);